export default "__VITE_ASSET__b00ad258__"